export class LaResults {
    public gridElement_id: number;
    public dso_internal_id: string;
    public type: string;
    public maxLoad: number;
    public maxLoadTimestamp: string;
    public maxCurrent: number;
    public maxApparentPower: number;
    public numberOfViolations: number;

    constructor(
        gridElement_id: number,
        dso_internal_id: string,
        type: string,
        maxLoad: number,
        maxLoadTimestamp: string,
        maxCurrent: number,
        maxApparentPower: number,
        numberOfViolations: number
    ) {
        this.gridElement_id = gridElement_id;
        this.dso_internal_id = dso_internal_id;
        this.type = type;
        this.maxLoad = maxLoad;
        this.maxLoadTimestamp = maxLoadTimestamp;
        this.maxCurrent = maxCurrent;
        this.maxApparentPower = maxApparentPower;
        this.numberOfViolations = numberOfViolations;
    }
}

export class LaPlanningResults {
    public gridElement_id: number; 
    public dso_internal_id: string; 
    public type: string; 
    public maxLoad: number;
    public numberOfViolations: number;
    public scenarioId: string;
    public maxLoadTimestamp: string;
    public maxCurrent: number;
    public maxApparentPower: number;

    constructor(
        gridElement_id: number,
        dso_internal_id: string,
        type: string,
        maxLoad: number,
        numberOfViolations: number,
        scenarioId: string,
        maxLoadTimestamp: string,
        maxCurrent: number,
        maxApparentPower: number
    ) {
        this.gridElement_id = gridElement_id;
        this.dso_internal_id = dso_internal_id;
        this.type = type;
        this.maxLoad = maxLoad;
        this.numberOfViolations = numberOfViolations;
        this.scenarioId = scenarioId;
        this.maxLoadTimestamp = maxLoadTimestamp;
        this.maxCurrent = maxCurrent;
        this.maxApparentPower = maxApparentPower;
    }
}